module.exports = __webpack_public_path__ + "img/1d41db0.png";